import React from 'react';
import { Button } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`
        flex items-center justify-center
        w-10 h-10 rounded-lg
        transition-all duration-200
        ${isDarkMode 
          ? 'text-brand-primary hover:bg-[rgba(13,136,126,0.12)] hover:text-brand-primary' 
          : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'
        }
        group
      `}
      title={isDarkMode ? 'تغییر به تم روشن' : 'تغییر به تم دارک'}
    >
      {isDarkMode ? (
        <SunOutlined className="text-lg group-hover:scale-110 transition-transform" />
      ) : (
        <MoonOutlined className="text-lg group-hover:scale-110 transition-transform" />
      )}
    </button>
  );
};

export default ThemeToggle;

